import { render, staticRenderFns } from "./InscripcionesProgramasUniversidadLayout.vue?vue&type=template&id=c86c1f20&scoped=true"
import script from "./InscripcionesProgramasUniversidadLayout.vue?vue&type=script&lang=js"
export * from "./InscripcionesProgramasUniversidadLayout.vue?vue&type=script&lang=js"
import style0 from "./InscripcionesProgramasUniversidadLayout.vue?vue&type=style&index=0&id=c86c1f20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c86c1f20",
  null
  
)

export default component.exports